import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AuthToken } from 'src/app/common/models/auth-token';
import { Settings } from 'src/app/common/models/settings';
import { User } from '../../common/models/user';
import { ClearAuthState, SetAuthTokenData, SetSettingsData, SetUserData, SetUserName } from './auth.actions';

export class AuthStateModel {
    user: User;
    token: AuthToken;
    settings: Settings;
}

@State<AuthStateModel>({
    name: 'auth',
    defaults: {
        user: {
            id: null,
            name: null,
            email: null,
            roles: null,
            lastLoginAt: null,
        },
        token: {
            expires: null
        },
        settings: {
            pagination: null,
            includeTagAliasesDuringTagQuickLookup: null
        }
    }
})

@Injectable()
export class AuthState {

    @Selector()
    static getAuthState(state: AuthStateModel) {
        return state;
    }

    @Selector()
    static user(state: AuthStateModel) {
        return state.user;
    }

    @Selector()
    static settings(state: AuthStateModel) {
        return state.settings;
    }

    @Action(SetUserData)
    public setUser({ getState, setState }: StateContext<AuthStateModel>, { user }: SetUserData) {
        const state = getState();
        setState({ ...state, user });
    }

    @Action(SetUserName)
    public setUserName({ getState, setState }: StateContext<AuthStateModel>, { name }: SetUserName) {
        const state = getState();

        setState({
            ...state,
            user: {
                ...state.user,
                name
            }
        });
    }

    @Action(SetSettingsData)
    public setSettingsData({ getState, setState }: StateContext<AuthStateModel>, { settings }: SetSettingsData) {
        const state = getState();
        setState({ ...state, settings });
    }

    @Action(SetAuthTokenData)
    public setAuthToken({ getState, setState }: StateContext<AuthStateModel>, { token }: SetAuthTokenData) {
        const state = getState();
        setState({ ...state, token });
    }

    @Action(ClearAuthState)
    public clearAuthState({ getState, setState }: StateContext<AuthStateModel>) {
        const state = getState();
        setState({ ...state, user: null, token: null, settings: null });
    }
}
